<ng-container *ngIf="block">
  <input class="form-control h-100" type="text" [placeholder]="block['label_' + helpersService.langCodeApi]"
    [(ngModel)]="value" (ngModelChange)="changeVal($event)" [ngClass]="{'border-active': value, 'firstInput': firstInput, 'lastInput': lastInput, 'oneInput': firstInput && lastInput, 'otherInput': !firstInput && !lastInput}">
</ng-container>